var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#160051"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6673 40C37.6673 40.5523 38.115 41 38.6673 41C39.2196 41 39.6673 40.5523 39.6673 40H37.6673ZM16.334 40C16.334 40.5523 16.7817 41 17.334 41C17.8863 41 18.334 40.5523 18.334 40H16.334ZM39.6673 40C39.6673 37.6898 38.1719 35.7497 36.0731 34.438C33.9603 33.1174 31.1036 32.3333 28.0007 32.3333V34.3333C30.7887 34.3333 33.2654 35.0416 35.0131 36.134C36.7749 37.2351 37.6673 38.6283 37.6673 40H39.6673ZM28.0007 32.3333C24.8977 32.3333 22.041 33.1174 19.9282 34.438C17.8294 35.7497 16.334 37.6898 16.334 40H18.334C18.334 38.6283 19.2264 37.2351 20.9882 36.134C22.7359 35.0416 25.2126 34.3333 28.0007 34.3333V32.3333ZM28.0007 28.3333C24.871 28.3333 22.334 25.7963 22.334 22.6667H20.334C20.334 26.9009 23.7665 30.3333 28.0007 30.3333V28.3333ZM22.334 22.6667C22.334 19.5371 24.871 17 28.0007 17V15C23.7665 15 20.334 18.4325 20.334 22.6667H22.334ZM28.0007 17C31.1303 17 33.6673 19.5371 33.6673 22.6667H35.6673C35.6673 18.4325 32.2348 15 28.0007 15V17ZM33.6673 22.6667C33.6673 25.7963 31.1303 28.3333 28.0007 28.3333V30.3333C32.2348 30.3333 35.6673 26.9009 35.6673 22.6667H33.6673Z",
    fill: "#F9FAFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.51a89c3ca5daace64e7e3da47eb2ef2d.svg";
export { ForwardRef as ReactComponent };